import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
    userKey: {
        id: 'userKeyDisplay.userKey',
        description: 'Label for displayed user key',
        defaultMessage: 'Account ID:',
    },
});
